import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UploadTenderDocumentMutationRequest, UploadTenderDocumentMutationResponse, UploadTenderDocumentQueryParams, UploadTenderDocument400, UploadTenderDocument401, UploadTenderDocument403, UploadTenderDocument422, UploadTenderDocument429, UploadTenderDocument500 } from "../types/UploadTenderDocument";

/**
 * @link /api/purchase-tenders/private/v1/tender/upload_document
 */

export function useUploadTenderDocument <TData = UploadTenderDocumentMutationResponse, TError = UploadTenderDocument400 | UploadTenderDocument401 | UploadTenderDocument403 | UploadTenderDocument422 | UploadTenderDocument429 | UploadTenderDocument500, TVariables = UploadTenderDocumentMutationRequest>(params: UploadTenderDocumentQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/purchase-tenders/private/v1/tender/upload_document`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
